<template>
  <section
    class="social-link-section"
    v-if="
      themeInfo.info?.business.whatsapp != null ||
      themeInfo.info?.business.telegram != null ||
      themeInfo.info?.business.instagram != null
    "
  >
    <hr class="section-separator" />
    <div class="title"><h2>ما را در شبکه های اجتماعی دنبال کنید</h2></div>
    <div class="social-networks-div">
      <a
        v-if="themeInfo.info?.business.whatsapp"
        :href="socialLinkCheck(themeInfo.info?.business.whatsapp, 'whatsapp')"
        target="_blank"
        class="whatsapp"
      ></a>
      <a
        v-if="themeInfo.info?.business.telegram"
        :href="socialLinkCheck(themeInfo.info?.business.telegram, 'telegram')"
        target="_blank"
        class="telegram"
      ></a>
      <a
        v-if="themeInfo.info?.business.instagram"
        :href="socialLinkCheck(themeInfo.info?.business.instagram, 'instagram')"
        target="_blank"
        class="instagram"
      ></a>
    </div>
    {{ ccc() }}
  </section>
</template>

<script>
//import { sellerData } from "@/repo/sellerData.js";
//import { membersData } from "@/repo/membersData.js";
import { mapGetters } from "vuex";
export default {
  name: "SocialLink",
  //mixins: [sellerData, membersData],
  data() {
    return {
      fullView: false,
    };
  },
  methods: {
    socialLinkCheck(link, type) {
      if (type == "instagram") {
        link = link.replace("https://", "");
        link = link.replace("www.instagram.com/", "");
        link = link.replace(" ", "");
        link = link.replace("instagram.com/", "");
        return "https://www.instagram.com/" + link.trim().toLowerCase();
      }
      if (type == "whatsapp") {
        link = link.replace("https://", "");
        link = link.replace(" ", "");
        link = link.replace("www", "");
        link = link.replace("wa.me/", "");
        return "https://wa.me/" + link.trim().toLowerCase();
      }
      if (type == "telegram") {
        link = link.replace("https://", "");
        link = link.replace(" ", "");
        link = link.replace("www", "");
        link = link.replace("t.me/", "");
        return "https://t.me/" + link.trim().toLowerCase();
      }
      return "";
    },
    ccc() {
      console.log("++++++++++++++++++++++++++++++++++++++++++");
      console.log(this.themeInfo);
    },
  },
  watch: {
    themeInfo: {
      handler(newValue) {
        console.log(newValue);
      },
      immediate: true,
    },
    baseInfo: {
      handler(newValue) {
        console.log(newValue);
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      themeInfo: "theme/themeInfo",
      baseInfo: "base/base",
    }),
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/socialLink/socialLink.css);
</style>